/**
 * MapFrostBackdrop — Premium Flow Rebuild Round 2.
 *
 * The pixel-identical frosted-navy backdrop shared between the rider's
 * wizard (ScheduleSetup) and the checkout Review/Pay page. Both surfaces
 * mount THIS same component so the cross-fade during route change
 * reveals no aesthetic seam.
 *
 * `level` drives blur + opacity:
 *   "off"        — invisible (map fully readable)
 *   "soft"       — 3px blur, 15/28/50 gradient (address entry)
 *   "mid"        — 6px blur, deeper gradient (route calc)
 *   "full"       — 10px blur, 45/60/90 gradient (wizard + pay)
 *
 * Reduced-motion: transition duration collapses to 0ms via the global
 * gate in index.css — swap is instant. */
import React from "react";

const LEVEL_STYLES = {
  off: {
    opacity: 0,
    blur: "blur(0)",
    gradient: "linear-gradient(180deg, rgba(10,17,40,0.15) 0%, rgba(10,17,40,0.28) 60%, rgba(7,13,31,0.5) 100%)",
  },
  soft: {
    opacity: 1,
    blur: "blur(3px)",
    gradient: "linear-gradient(180deg, rgba(10,17,40,0.15) 0%, rgba(10,17,40,0.28) 60%, rgba(7,13,31,0.5) 100%)",
  },
  mid: {
    opacity: 1,
    blur: "blur(6px)",
    gradient: "linear-gradient(180deg, rgba(10,17,40,0.30) 0%, rgba(10,17,40,0.45) 40%, rgba(7,13,31,0.72) 100%)",
  },
  full: {
    opacity: 1,
    blur: "blur(10px)",
    gradient: "linear-gradient(180deg, rgba(10,17,40,0.45) 0%, rgba(10,17,40,0.60) 30%, rgba(7,13,31,0.90) 100%)",
  },
};

export default function MapFrostBackdrop({ level = "off", zIndex = 3, testId = "map-frost-overlay" }) {
  const s = LEVEL_STYLES[level] || LEVEL_STYLES.off;
  return (
    <div
      className="fixed inset-0 pointer-events-none"
      style={{
        zIndex,
        opacity: s.opacity,
        backdropFilter: s.blur,
        WebkitBackdropFilter: s.blur,
        background: s.gradient,
        transition: "opacity var(--motion-slow) var(--ease-out), backdrop-filter var(--motion-slow) var(--ease-out), background var(--motion-slow) var(--ease-out)",
      }}
      data-testid={testId}
      data-frost-level={level}
      aria-hidden="true"
    />
  );
}
